import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { CreateInitiative } from '@ui/initiatives';
import { InitiativesSummaryNotifications } from './notifications';
import { InitiativesTable } from './InitiativesTable';
import React from 'react';
import { useCurrentUser } from '@hooks';
import { SonarCard, ViewArea } from '@ui/general';
export const InitiativesSummaryIndex = () => {
    const { isReadOnly } = useCurrentUser();
    return (React.createElement(ViewArea, { id: 'initiatives-view' },
        React.createElement(SonarCard, { extra: !isReadOnly && React.createElement(CreateInitiative, { noPadding: true, source: 'menu' }), noSpacingX: true, title: COPY_SPECIFIC.INITIATIVES },
            React.createElement(InitiativesTable, { id: 'initiatives-table' })),
        React.createElement(InitiativesSummaryNotifications, null)));
};
